// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24px\" height=\"24px\" fill=\"#0e7fa0\"><path d=\"M0 0h24v24H0z\" fill=\"none\"/><path d=\"M2.01 21L23 12 2.01 3 2 10l15 2-15 2z\"/></svg>";
// Exports
module.exports = code;